import styled from '@emotion/styled';
import { trackKakaoPageView, trackKakaoPurchase } from 'hooks/util/useKakaoPixel';
import { useEffect } from 'react';
import ReactPixel from 'react-facebook-pixel';

const Price:React.FC<any> =  () => {
  // useEffect(() => {
  //   trackKakaoPageView(process.env.REACT_APP_KAKAO_PIXEL_ID!, 'plan');
  // },[])
  // const navigate = useNavigate();
  const handleGoToSubscriptionCouponInSmartStore = () => {
    // ReactPixel.track('Purchase', {
    //   value: '10,000.0', // 구매 금액
    //   currency: 'KRW',
    // });
    
    // trackKakaoPurchase({
    //   pixelId: process.env.REACT_APP_KAKAO_PIXEL_ID!,
    //   total_quantity: 1,
    //   total_price: 100000,
    //   products: [
    //     {id: 'coupon-12month', name: '12개월 구독권', quantity: 1, price: 100000}
    //   ],
    //   tag: '12month',
    // });
      
    setTimeout(() => {
      window.location.href = "https://smartstore.naver.com/photypeta/products/11013297084?nl-query=%ED%8F%AC%ED%8B%B0%ED%8E%98%ED%83%80&nl-ts-pid=iGg68sqo15VssBJ9aKsssssstw4-451153&NaPm=ct%3Dm5urnjg8%7Cci%3D7b2a900520d3ae16a51837b1e55400f287ce24cf%7Ctr%3Dsls%7Csn%3D2148378%7Chk%3D23f7716ae66689ff3d2fa417f07bcc629593900f"
    }, 300)
  }


  const handleGoToPriceInSmartStore = () => {    
    // ReactPixel.track('Purchase', {
    //   value: '10,000.0', // 구매 금액
    //   currency: 'KRW',
    // })
    // trackKakaoPurchase({
    //   pixelId: process.env.REACT_APP_KAKAO_PIXEL_ID!,
    //   total_quantity: 1,
    //   total_price: 100000,
    //   products: [
    //     {id: 'coupon-1set', name: '1권 Set', quantity: 1, price: 100000}
    //   ],
    //   tag: '1Album set'
    // });
    setTimeout(() => {
      window.location.href = "https://smartstore.naver.com/photypeta/products/10366508481?nl-query=%ED%8F%AC%ED%8B%B0%ED%8E%98%ED%83%80&nl-ts-pid=iGg68sqo15VssBJ9aKsssssstw4-451153&NaPm=ct%3Dm5uro5ts%7Cci%3Df746aeda5ac647417e31b1d4b2aa10fc1c68925e%7Ctr%3Dsls%7Csn%3D2148378%7Chk%3D4a322ed97c0819746253126fc8f2b9a5f624bcfb"
    }, 300)
  }


  const smartSubscriptionCouponInSmartStore = () => {
    ReactPixel.track('Purchase', {
      value: '10,000.0', // 구매 금액
      currency: 'KRW',
    });

    setTimeout(() => {
      window.location.href = "https://smartstore.naver.com/photypeta/products/11013297084?nl-query=%ED%8F%AC%ED%8B%B0%ED%8E%98%ED%83%80&nl-ts-pid=iGg68sqo15VssBJ9aKsssssstw4-451153&NaPm=ct%3Dm5urnjg8%7Cci%3D7b2a900520d3ae16a51837b1e55400f287ce24cf%7Ctr%3Dsls%7Csn%3D2148378%7Chk%3D23f7716ae66689ff3d2fa417f07bcc629593900f"
    }, 300)
  }

  const smartPriceInSmartStore = () => {    
    ReactPixel.track('Purchase', {
      value: '10,000.0', // 구매 금액
      currency: 'KRW',
    });

    setTimeout(() => {
      window.location.href = "https://smartstore.naver.com/photypeta/products/10366508481?nl-query=%ED%8F%AC%ED%8B%B0%ED%8E%98%ED%83%80&nl-ts-pid=iGg68sqo15VssBJ9aKsssssstw4-451153&NaPm=ct%3Dm5uro5ts%7Cci%3Df746aeda5ac647417e31b1d4b2aa10fc1c68925e%7Ctr%3Dsls%7Csn%3D2148378%7Chk%3D4a322ed97c0819746253126fc8f2b9a5f624bcfb"
    }, 300)
  }

  // useEffect(() => {
  //   // 최초 진입 시 1회만 실행
  //   ReactPixel.track('Purchase', {
  //     value: '10,000.0', // 구매 금액
  //     currency: 'KRW',
  //   });
  
  // }, []); // 빈 배열: mount 시 딱 한 번만
    

  return (
    <Container>
      <TextContainer>
        <BolderText className='bold'>
          지금 모으기 시작도<br/> 밀린 사진 한 번에 인화도<br/> 포티페타!
        </BolderText>
        <BolderText className='small'>
          잃어버릴 걱정 없이<br/> 디지털과 아날로그로 함께 보관
        </BolderText>
      </TextContainer>
      <SmartButtonContainer> 
        <SmartButton onClick={smartSubscriptionCouponInSmartStore}></SmartButton>
        <SmartButton onClick={smartPriceInSmartStore}></SmartButton>
      </SmartButtonContainer>
      <InformationContainer className='first'>
        <ImgContainer>
          <Img src='/images/millie/firstBlock.png'/>
        </ImgContainer>
        <ButtonWrapper>
          <ButtonContainer>
            <TooltipWrapper>
              스마트 스토어 20%
            <TooltipArrow/>
            </TooltipWrapper>
            <SubscribeButton onClick={handleGoToSubscriptionCouponInSmartStore}>
            구독권 보러가기
            </SubscribeButton>
          </ButtonContainer>
        </ButtonWrapper>
      </InformationContainer>
      <InformationContainer className='second'>
        <ImgContainer>
          <Img src='/images/millie/secondBlock.png'/>
        </ImgContainer>
        <ButtonWrapper>
          <ButtonContainer>
            <TooltipWrapper>
              스마트 스토어 30%
            <TooltipArrow/>
            </TooltipWrapper>
            <SubscribeButton onClick={handleGoToPriceInSmartStore}>
              앨범 신청하러 가기
            </SubscribeButton>
          </ButtonContainer>
        </ButtonWrapper>
      </InformationContainer>
    </Container>
  )
};

export default Price;

const Container = styled.div`
  width: 100%;
  /* min-height: 600px; */
  /* min-height: 00px; */
  display: flex;
  flex-direction: column;
  background-color: #D2815F;
  /* background-color: #F0E9DF; */
  /* background-size: contain; */
  /* margin-bottom: 150px; */
`;

const ImgContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
`;


const Img = styled.img`
  &.first {
    width: 100%;
    margin-bottom: 10px;
  }

  &.second {
    height: 30px;
    height: 100%;
    margin: 0 auto 20px;
    width: 70%;
  }
  
  &.third {
    margin: 0 auto;
    height: 30px;
    height: 100%;
    width: 65%;
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 200px;
  /* background-color: black; */
  margin: 104.7px auto 0;
  width: 90%;
`;

const BolderText = styled.div`
  letter-spacing: -1.0px;
  &.bold {
    display: flex;
    margin: 0 auto;
    text-align: center;

    font-size: 33px;
    font-weight: 600;
    color: white;
    /* color: #ABA497; */
  }

  &.small{
    display: flex;
    margin: 45.15px auto 0;
    text-align: center;

    font-size: 16px;
    line-height: 1.7;
    color: white;
    /* color: #ABA497; */
  }
`;

const InformationContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
  min-height: 500px;
  background-color: white;
  border-radius: 30px;

  &.first {
    margin: 20px auto 30px;
  }

  &.second {
    margin: 0 auto 150px;
  }
`;

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const ButtonContainer = styled.div`
  width: 85%;
  height: 50px;
  color: white;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  margin: 40px auto 25px;
  z-index: 999;
  position: relative;
`;

const SubscribeButton = styled.button`
  width: 100%;
  height: 100%;
  font-weight: bold;
  background-color: black;
  color: white;
  border-radius: 15px;
`;

const TooltipWrapper = styled.div`
  position: absolute;
  bottom: 90%; // 버튼 위에 위치
  left: 50%;
  transform: translateX(-50%); 
  background-color: #58CD57;
  /* color: white; */
  color: white;
  padding: 5px 12px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -1.0px;
  white-space: nowrap;
  opacity: 1; /* 항상 보이도록 설정 */
  visibility: visible;
  z-index: 1000;
`;

const TooltipArrow = styled.div`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #58CD57;
`;

const SmartButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 30%;
  margin: 10px auto;
`;

const SmartButton = styled.button`
  background-color: #D2815F;
`